import dayjs from "dayjs";
import { t } from "i18next";
import { get, lowerCase } from "lodash";
import { useEffect, useRef, useState } from "react";
import { Box, Typography, Link } from "@mui/material";

function Header({ training, showInfo, dateFormat }) {
  const getDate = () => {
    let currentFormat = getFormatUser() ?? "DD/MM/YYYY HH:mm";

    return get(training, "training.creation_date")
      ? dayjs(get(training, "training.creation_date")).format(currentFormat)
      : " - ";
  };

  const getFormatUser = () => {
    if (!dateFormat) return null;

    let charMapper = {
      d: "DD",
      m: "MM",
      y: "YYYY",
    };

    let joinChar = "-";

    return String(dateFormat)
      .split("/")
      .map((char) => charMapper[lowerCase(char)])
      .join(joinChar)
      .concat(" HH:mm");
  };

  const getTrainingType = () => {
    let type = training?.training?.training_type?.display_name;
    let auto = training?.training?.training_type_automatic?.display_name;
    if (type) {
      return type;
    } else if (auto) {
      return auto;
    } else {
      return null;
    }
  };

  const getTrackName = () => {
    let type = training?.training?.track_name?.display_name;
    let auto = training?.training?.track_name_automatic?.display_name;
    if (type) {
      return type;
    } else if (auto) {
      return auto;
    } else {
      return null;
    }
  };

  const getComment = () => {
    return get(training, "training.comment", null);
  };

  const getArioneoComment = () => {
    return get(training, "training.flash_comment", null);
  };

  const getAutomaticComment = () => {
    return get(training, "training.comment_automatic", null);
  };

  const getInfo = () => {
    let info = [];
    if (getTrainingType()) {
      info = [getTrainingType()];
    }
    if (getTrackName()) {
      info = [...info, getTrackName()];
    }
    if (get(training, "training.rider.display_name", null)) {
      info = [...info, get(training, "training.rider.display_name", null)];
    }
    return info;
  };

  const CommentBox = ({ url, maxHeight }) => {
    const [isTruncated, setIsTruncated] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
      if (contentRef.current.scrollHeight > maxHeight) {
        setIsTruncated(true);
      }
    }, [maxHeight]);

    var contentBoxMaxHeight = maxHeight + 12;

    return (
      <Box
        className="content-box"
        sx={{ maxHeight: `${contentBoxMaxHeight}px` }}
      >
        <Typography
          component="p"
          ref={contentRef}
          className={"content " + (isTruncated ? "truncated" : "")}
          sx={{
            maxHeight: `${maxHeight}px`,
            fontWeight: 400,
            fontSize: "0.75rem",
          }}
        >
          {getComment() ? (
            <Typography
              component="p"
              sx={{
                fontWeight: 400,
                display: "flex",
                gap: 0.5,
                fontSize: "0.75rem",
              }}
            >
              <Box
                component="span"
                sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
              >
                {t("editTrainingForm:comment:label")} :
              </Box>
              {getComment()}{" "}
            </Typography>
          ) : getArioneoComment() ? (
            <Typography
              component="p"
              sx={{
                fontWeight: 400,
                display: "flex",
                gap: 0.5,
                fontSize: "0.75rem",
              }}
            >
              <Box
                component="span"
                sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
              >
                {t("qualification:commentArioneo")} :{" "}
              </Box>
              {getArioneoComment()}{" "}
            </Typography>
          ) : (
            getAutomaticComment() && (
              <Typography
                component="p"
                sx={{ fontWeight: 400, fontSize: "0.75rem" }}
              >
                <Box component="span" sx={{ fontWeight: 600 }}>
                  {"Arion Intelligence (Beta) * : "}
                </Box>
                {getAutomaticComment()}
              </Typography>
            )
          )}
        </Typography>
        {isTruncated && (
          <Typography component="p" sx={{ width: "100%", textAlign: "center" }}>
            <Link
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              className="see-more-link"
              sx={{ fontSize: "0.75rem" }}
            >
              {t("seeMore")}
            </Link>
          </Typography>
        )}
      </Box>
    );
  };

  return (
    <Box sx={{ mt: 0.5 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Box
          className="bg-gradient"
          sx={{
            p: 0.5,
            px: { xs: 1, md: 2 },
            width: "75%",
            borderTopRightRadius: "9999px",
            borderBottomRightRadius: "9999px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            component="p"
            sx={{
              fontSize: { xs: "1.125rem", md: "1.25rem" },
              color: "#fff",
              fontWeight: 600,
            }}
          >
            {get(training, "training.horse_trainer.horse.name", "-")}
          </Typography>
          <Typography
            component="p"
            variant="subtitle2"
            sx={{
             
              color: "#fff",
              fontWeight: 500,
            }}
          >
            {getDate()}
          </Typography>
        </Box>

        <Box
          component="img"
          src="/arioneo_logo_white.png"
          alt=""
          sx={{
            filter: "grayscale(100%)",
            pr: 2.5,
            height: "100%",
            width: { xs: "4rem", md: "4rem" },
          }}
        />
      </Box>

      {showInfo && (
        <Box sx={{ py: 0.5, px: 2.5 }}>
          <Typography component="p" sx={{ fontSize: "0.75rem" }}>
            {getInfo().join(" - ")}
          </Typography>
          {(getComment() || getArioneoComment() || getAutomaticComment()) && (
            <CommentBox
              url={get(training, "training.public_url", null)}
              maxHeight={120}
            />
          )}
        </Box>
      )}
    </Box>
  );
}

export default Header;
